<template>
    <div class="footer d-flex flex-column justify-end text-center mb-5">
        <employee-login class="d-md-none text-center" v-if="accountType != 'student' && accountType != 'parent'" />
        <a href="https://www.renaissance.com/privacy/" target="_blank" class="d-block fade-in"
            v-if="showPrivacyPolicy">Privacy Policy</a>
        <span>&copy; {{ year }} Renaissance Learning, Inc. All rights reserved.</span>
    </div>
</template>

<script>
import EmployeeLogin from '@/components/EmployeeLogin'

export default {
    name: 'BrandFooter',
    components: {
        EmployeeLogin
    },
    data() {
        return {
            year: function () {
                const currentDate = new Date();

                return currentDate.getFullYear();
            }()
        }
    },
    props: {
        accountType: {
            type: String
        }
    },
    computed: {
        showPrivacyPolicy() {
            return this.accountType === 'parent'
        }
    }
}

</script>


<style scoped>
.ren-logo {
    height: 18px;
    display: inline;
    transform: translateY(+15%);
}

.footer {
    font-size: 14px;
    color: #202020;
}
</style>
